import * as React from 'react';
import styled from 'styled-components';
import penn_storage_logo from 'src/assets/penn_storage_logo.svg';
import pricing_icon from 'src/assets/icons/pricing_icon.svg';

const PricingCardContainer = styled.div`
  width: 260px;
  background: #ffffff;
  border-radius: 4px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const PriceText = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: bold;
  font-size: 60px;
  line-height: 86px;
  text-align: center;

  color: #00144d;

  margin-top: 12px;
  margin-bottom: 0px !important;
`;

const PerkText = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: center;

  color: rgba(0, 20, 77, 0.86);
`;

const BoxText = styled.p`
  margin-top: 12px;
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  text-align: center;
  margin-bottom: 4px;

  color: #00144d;
`;

const EntireSummerText = styled.p`
  margin-bottom: 20px;
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 17px;
  text-align: center;

  color: rgba(0, 20, 77, 0.7);
`;

const PricingCard = () => {
  return (
    <PricingCardContainer>
      <img style={{ marginTop: '28px' }} src={penn_storage_logo} />
      <PriceText>$23</PriceText>
      <BoxText>/ box</BoxText>
      <EntireSummerText>(for the entire summer)</EntireSummerText>
      <PerkText>All Items Insured</PerkText>
      <PerkText>Free Tape/Boxes</PerkText>
      <PerkText>Clean, Verified Storage Space</PerkText>
      <img src={pricing_icon} />
    </PricingCardContainer>
  );
};

export default PricingCard;



// WEBPACK FOOTER //
// ./src/pages/LandingPage/components/PricingCard.tsx